export default __webpack_public_path__ + "static/media/screen4.5f55478d.png";